export const isProduction = (): boolean => window.process.env.ENVIRONMENT === 'production';
export const isStaging = (): boolean => window.process.env.ENVIRONMENT === 'staging';
export const isDev = (): boolean => !isProduction() && !isStaging();
